import type { BasicContentItem } from '@ps/web-core-store';
import type { SportsWidgetBlock } from '@ps/web-martech-cms-types/Main';
import hash from 'object-hash';

import type { BasicSportsWidgetConfig, SectionWidgetConfig, SupportedBlockTypeMap } from './types';

export const buildBlockAndItem = <T extends keyof SupportedBlockTypeMap>(
  blockType: T,
  sectionWidgetConfig: SectionWidgetConfig
): { block: SupportedBlockTypeMap[T]; widget: BasicSportsWidgetConfig } => {
  const { title, _content_type_uid, ...rest } = sectionWidgetConfig;
  const [, ...slugs] = title
    .toLowerCase()
    .split(' ')
    .filter((slug) => slug !== 'widget');
  const prefix = blockType.startsWith('sports') ? `isp-sports-widget` : blockType.replace('_', '-');
  let uid = [prefix, ...slugs].join('-');

  if (Object.keys(rest).length) {
    const configHash = hash(rest).substring(0, 8);
    uid += `/${configHash}`;
  }

  return {
    block: {
      [blockType]: {
        reference: [
          {
            uid,
            _content_type_uid
          }
        ]
      }
    } as unknown as SupportedBlockTypeMap[T],
    widget: {
      _content_type_uid,
      uid,
      title,
      ...rest
    } as BasicSportsWidgetConfig
  };
};

export const buildMainSection = (templateWidgets: SectionWidgetConfig[]) =>
  templateWidgets.reduce<{
    blocks: SportsWidgetBlock[];
    widgets: Record<BasicSportsWidgetConfig['title'], BasicContentItem>;
  }>(
    (acc, cur) => {
      const { block, widget } = buildBlockAndItem('sports_widget', cur);
      acc.blocks.push(block);
      acc.widgets[widget.uid as BasicSportsWidgetConfig['title']] = widget;
      return acc;
    },
    { blocks: [], widgets: {} }
  );
